export default __webpack_public_path__ + "static/media/Eo_circle_green_blank.svg.120e3590.png";